import { getConditionNodeConditionGroups } from 'common/builder/components/chart/FlowChart/adapters/generic/nodes/converterRules/helpers/getConditionNodeConditions'
import { getConditionNodeNextStep } from 'common/builder/components/chart/FlowChart/adapters/generic/nodes/converterRules/helpers/getConditionNodeNextStep'
import { FlowChartIconBuilder } from 'common/builder/components/chart/FlowChart/lib/builders/FlowChartIconBuilder'
import { FlowChartNodeHeaderBuilder } from 'common/builder/components/chart/FlowChart/lib/builders/FlowChartNodeHeaderBuilder'
import {
  ConverterRule,
  NodeConverterRulePayload,
} from 'common/builder/components/chart/FlowChart/lib/types'
import {
  ConditionConfig,
  DEFAULT_ICON_RENDER_SIZE,
} from 'common/builder/components/chart/FlowChart/nodes/shared/config'
import { FlowChartConditionNode } from 'common/builder/components/chart/FlowChart/types/FlowChartNode/FlowChartConditionNode'
import { FlowChartNodeType } from 'common/builder/components/chart/FlowChart/types/FlowChartNode/FlowChartNodeType'
import { NodeType } from 'common/builder/constants/NodeType'
import { IConditionNode } from 'common/builder/nodes/nodeInterfaces'
import { getFlowConditionFields } from 'common/builder/selectors/builder/fieldsSelectors'
import { filterFieldMapper } from 'common/filter/filterFieldMapper'
import { getSegmentsById } from 'common/filter/selectors/segmentsSelectors'
import { getActiveReasons } from 'common/oneTimeNotify/selectors/notifyReasonSelectors'

export const ConditionNodeGenericConverterRule: ConverterRule<
  IConditionNode,
  FlowChartConditionNode,
  NodeConverterRulePayload
> = {
  predicate: (entity: IConditionNode) => entity?.nodeType === NodeType.CONDITION,

  convert: (entity: IConditionNode, { blocks, state, builderId, timezone }) => {
    const nodeBlocks = entity.blocks.map((blockId) => blocks[blockId]).filter(Boolean)
    const conditionFields = getFlowConditionFields(state, builderId).map(filterFieldMapper)
    const segmentsMap = getSegmentsById(state)
    const activeReasons = getActiveReasons(state)

    const conditions = getConditionNodeConditionGroups({
      blocks: nodeBlocks,
      timezone,
      fields: conditionFields,
      segments: segmentsMap,
      notificationReasons: activeReasons,
    })

    const nextStep = getConditionNodeNextStep({
      blocks: nodeBlocks,
      conditionsLength: conditions.length,
    })

    const icon = new FlowChartIconBuilder(ConditionConfig.iconComponent, DEFAULT_ICON_RENDER_SIZE)

    if (ConditionConfig.iconColor) {
      icon.withColor(ConditionConfig.iconColor)
    }

    const node: FlowChartConditionNode = {
      id: entity.id,
      nodeType: NodeType.CONDITION,
      type: FlowChartNodeType.CONDITION,
      onboardingElementId: entity.onboardingElementId,
      data: {
        header: new FlowChartNodeHeaderBuilder(entity.caption)
          .withColor(ConditionConfig.headerBackground)
          .withIcon(icon.build())
          .build(),
        conditionGroups: conditions,
        nextStep,
      },
    }

    return node
  },
}
